module.exports = __webpack_public_path__ + "r-v3/img/ml_05_00_over.9940637b.jpg";